import i18n from "i18next";

import { initReactI18next } from "react-i18next";

// Import translation files
import components from "assets/locales/en/components.json";
import editor from "assets/locales/en/editor.json";
import editorCast from "assets/locales/en/editorCast.json";
import editorStory from "assets/locales/en/editorStory.json";
import editorWorld from "assets/locales/en/editorWorld.json";
import error from "assets/locales/en/error.json";
import game from "assets/locales/en/game.json";
import general from "assets/locales/en/general.json";
import landing from "assets/locales/en/landing.json";
import library from "assets/locales/en/library.json";
import login from "assets/locales/en/login.json";
import notFound from "assets/locales/en/notFound.json";
import rewrite from "assets/locales/en/rewrite.json";

const namespacesToPreload: string[] = [
  "general",
  "components",
  "login",
  "game",
  "landing",
  "library",
  "rewrite",
  "editor",
  "editorWorld",
  "editorCast",
  "editorStory",
];

i18n.use(initReactI18next).init({
  fallbackLng: ["en"],
  debug: false,
  returnObjects: true,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      components,
      editor,
      editorCast,
      editorStory,
      editorWorld,
      error,
      game,
      general,
      landing,
      library,
      login,
      notFound,
      rewrite,
    },
  },
  lng: "en", // default language
  ns: namespacesToPreload,
  defaultNS: "general",
});

export default i18n;
